<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between align-items-start pt-3 pb-2 mb-3 border-bottom"
    >
      <div class="d-inline-flex">
        <h1 class="h2">{{ title }}</h1>

        <hr class="vertical-bar" />
      </div>

      <b-form-input
        autofocus
        v-on:keyup.enter="search"
        v-model="viewData.search"
        placeholder="Digite um termo e pressione enter para buscar"
        class="mr-3"
      ></b-form-input>

      <BaseButtonComponent :to="`/user/new/${profile}`" variant="primary-action"
        >Novo</BaseButtonComponent
      >

      <vue-json-to-csv
        block
        style="width: 10em"
        :json-data="state.listCSV"
        :separator="';'"
        class="ml-3"
      >
        <BaseButtonComponent block variant="primary-action">
          CSV
        </BaseButtonComponent>
      </vue-json-to-csv>
    </div>

    <loading-list v-if="viewData.loading"></loading-list>
    <div
      class="d-flex justify-content-between flex-column h-100"
      v-else-if="!viewData.loading && state.list && state.list.length > 0"
    >
      <v-table>
        <thead>
          <tr>
            <td>Atalhos</td>
            <td>Aprovado</td>
            <td>Nome</td>
            <td>CPF/CNPJ</td>
            <td>Email</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td style="text-align: left">
              <BaseButtonComponent
                v-if="
                  profile === 'consumer' &&
                    item.parentAccount &&
                    item.parentAccount.profile === 'trader'
                "
                size="sm"
                :to="`/user/${item.id}/sales-comissions/${item.accountId}`"
                v-b-tooltip.hover
                title="Comissões"
                variant="info"
              >
                <b-icon-cash></b-icon-cash>
              </BaseButtonComponent>

              <BaseButtonComponent
                v-if="profile === 'partner'"
                size="sm"
                :to="`/user/${item.id}/bonuses/${item.accountId}`"
                v-b-tooltip.hover
                title="Bônus"
                variant="info"
              >
                <b-icon-cash></b-icon-cash>
              </BaseButtonComponent>

              <BaseButtonComponent
                v-if="profile === 'trader'"
                size="sm"
                :to="
                  `/user/${item.id}/sales-comissions-report/${item.accountId}`
                "
                v-b-tooltip.hover
                title="Comissões"
                variant="secondary-action"
              >
                <b-icon-cash></b-icon-cash>
              </BaseButtonComponent>

              <BaseButtonComponent
                v-if="profile === 'consumer'"
                size="sm"
                :to="`/user/${item.id}/installations/${item.accountId}`"
                v-b-tooltip.hover
                title="Instalações"
                variant="secondary-action"
              >
                <b-icon-lightning></b-icon-lightning>
              </BaseButtonComponent>

              <BaseButtonComponent
                size="sm"
                :to="`/user/edit/${item.id}/${item.accountProfile}`"
                v-b-tooltip.hover
                title="Editar"
                variant="secondary-action"
              >
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </BaseButtonComponent>

              <BaseButtonComponent
                v-if="item.accountProfile === 'consumer'"
                size="sm"
                :to="`/user/view/${item.id}/consumer`"
                v-b-tooltip.hover
                title="Ver cadastro"
                variant="secondary-action"
              >
                <b-icon icon="eye" aria-hidden="true"></b-icon>
              </BaseButtonComponent>

              <BaseButtonComponent
                size="sm"
                :to="`/user/${item.id}/invoices/${item.accountProfile}`"
                v-b-tooltip.hover
                title="Ver Notas Fiscais"
                variant="secondary-action"
              >
                <b-icon icon="file-text" aria-hidden="true"></b-icon>
              </BaseButtonComponent>

              <BaseButtonComponent
                size="sm"
                @click="() => remove(item)"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
            <td>
              <b-icon
                v-if="item.loading"
                icon="arrow-clockwise"
                animation="spin"
                font-scale="2"
              ></b-icon>
              <b-form-checkbox
                v-else
                @change="() => setStatus(item)"
                switch
                size="lg"
                v-model="item.approved"
              ></b-form-checkbox>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ formatSocialNumber(item.socialNumber) }}</td>
            <td>{{ item.email }}</td>
          </tr>
        </tbody>
      </v-table>
      <b-pagination-nav
        class="mt-3"
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import Vue from 'vue';
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import moment from 'moment-timezone';
import VueJsonToCsv from 'vue-json-to-csv';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'users-index',
  data: function() {
    return {
      state: {
        list: [],
        page: 1,
        pageCount: 1,
        count: 0,
        listCSV: [],
      },
      viewData: {
        loading: true,
        search: '',
      },
    };
  },
  computed: {
    title() {
      if (this.profile === 'consumer') return 'Consumidores';
      if (this.profile === 'trader') return 'Comercializadores';
      if (this.profile === 'partner') return 'Parceiros';
      if (this.profile === 'investor') return 'Investidores';
    },
    profile() {
      return this.$route.path
        ? this.$route.path.substring(1, this.$route.path.length - 1)
        : 'consumer';
    },
  },
  beforeMount: async function() {
    moment.locale('pt-BR');

    if (this.$route.query && this.$route.query.search) {
      this.viewData.search = this.$route.query.search;
    }

    this.$router.push({
      query: {
        page: this.$route.query.page || 1,
        profile: this.profile,
        showPending: true,
        search: this.viewData.search,
      },
    });

    await this.getAll();
  },
  methods: {
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    formatSocialNumber(socialNumber) {
      if (socialNumber.length === 11) {
        return socialNumber.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/g,
          '$1.$2.$3-$4',
        );
      } else {
        return socialNumber.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
          '$1.$2.$3/$4-$5',
        );
      }
    },
    formatDate(date) {
      return date ? moment(date).format('L') : '';
    },
    search() {
      this.$router.push({
        query: { page: 1, search: this.viewData.search, profile: this.profile },
      });
    },
    async getAll() {
      this.viewData.loading = true;

      try {
        const result = await API.post('/execute', {
          path: '/users' + helpers.toQueryString(this.$route.query),
          method: 'get',
        });

        this.state = { ...result.model };

        this.state.listCSV = this.state.list.map(item => ({
          Aprovado: item.approved ? 'Não' : 'Sim',
          Nome: item.name,
          CPF_CNPJ: this.formatSocialNumber(item.socialNumber),
          Email: item.email,
        }));
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }

      this.viewData.loading = false;
    },
    async setStatus(item) {
      const index = this.state.list.indexOf(item);

      item.loading = true;

      try {
        await API.post('/execute', {
          path: `/user/${item.id}/status/${!item.approved}`,
          method: 'put',
        });

        this.$toast.success('Status atualizado com sucesso');
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }

      item.loading = false;
      Vue.set(this.state.list, index, item);
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Deseja mesmo excluir o usuário [${item.name}] ?`,
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        await API.post('/execute', {
          path: '/user/' + item.id,
          method: 'delete',
        });

        this.$toast.success('Usuário excluído com sucesso');
        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex), {
          duration: 10000,
        });
      }

      this.viewData.loading = false;
    },
  },
  components: {
    VueJsonToCsv,
    BaseButtonComponent,
  },
};
</script>
